import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import useTranslation from "../../i18n/useTranslation";

const DeleteAccountInfo = () => {
    const { t } = useTranslation();

    useEffect(() => {
        const prevTitle = document.title;
        document.title = t("deleteAccount.meta.title");

        return () => {
            document.title = prevTitle;
        };
    }, [t]);

    return (
        <div
            style={{
                backgroundColor: "#14151a",
                color: "#ffffff",
                fontFamily: "'Poppins', sans-serif",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 20,
                overflowX: "hidden",
            }}
        >
            <div
                className="card card-outline"
                style={{
                    backgroundColor: "#1f1f2e",
                    borderRadius: "12px",
                    padding: "32px",
                    maxWidth: "600px",
                    width: "100%",
                    boxShadow: "0 0 15px rgba(0, 0, 0, 0.3)",
                }}
            >
                {/* Header */}
                <div className="text-center mb-4">
                    <NavLink to="/">
                        <img
                            src="/dist/img/angeonx-sports.png"
                            alt={t("deleteAccount.brand.logoAlt")}
                            style={{ height: "70px", marginBottom: 10 }}
                        />
                    </NavLink>

                    <h2
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "var(--kbs-primary, #00adff)",
                            marginBottom: 8,
                        }}
                    >
                        {t("deleteAccount.brand.namePrimary")}{" "}
                        <span style={{ color: "#ffffff" }}>
                            {t("deleteAccount.brand.nameSecondary")}
                        </span>
                    </h2>
                </div>

                <h1
                    style={{
                        color: "var(--kbs-primary, #00adff)",
                        fontSize: 22,
                        marginBottom: 16,
                        textAlign: "center",
                    }}
                >
                    {t("deleteAccount.content.title")}
                </h1>

                <p style={{ lineHeight: 1.6 }}>
                    {t("deleteAccount.content.intro")}
                </p>

                <ol
                    style={{
                        paddingLeft: 20,
                        marginTop: 12,
                        marginBottom: 20,
                    }}
                >
                    <li>{t("deleteAccount.steps.openApp")}</li>
                    <li>
                        <strong>{t("deleteAccount.steps.goSettings")}</strong>
                    </li>
                    <li>
                        <strong>{t("deleteAccount.steps.tapDelete")}</strong>
                    </li>
                </ol>

                <p style={{ lineHeight: 1.6 }}>
                    {t("deleteAccount.help.emailIntro")}{" "}
                    <a
                        href="mailto:info@angeonx.com"
                        style={{ color: "#8d929d" }}
                    >
                        kbolasports@angeonx.com
                    </a>{" "}
                    {t("deleteAccount.help.emailInstruction")}
                </p>

                <p>{t("deleteAccount.help.processingTime")}</p>

                <NavLink
                    to="/login"
                    className="text-center d-block"
                    style={{
                        color: "var(--kbs-primary, #00adff)",
                        fontWeight: "bold",
                        textDecoration: "underline",
                        fontSize: "16px",
                        marginTop: 24,
                    }}
                >
                    {t("deleteAccount.actions.backToLogin")}
                </NavLink>
            </div>
        </div>
    );
};

export default DeleteAccountInfo;
